import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  CustomFieldTypes,
  UpdateOrganizationCustomFieldCommand,
} from 'src/app/core/api/models';
import { OrganizationCustomFieldsService } from 'src/app/core/api/services';
import { CreateOrganizationCustomFieldCommand } from '../../../../core/api/models/create-organization-custom-field-command';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from '../../../shared/base/modules/base-form.module';

@Component({
    selector: 'app-organization-custom-fields-form',
    templateUrl: './organization-custom-fields-form.component.html',
    imports: [BaseFormModule]
})
export class OrganizationCustomFieldsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<any> = {};
  model: CreateOrganizationCustomFieldCommand = {};

  get CustomFieldTypes() {
    return CustomFieldTypes;
  }

  //#endregion

  constructor(protected currentService: OrganizationCustomFieldsService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      nameEn: new FormControl('', Validators.required),
      nameFa: new FormControl('', Validators.required),
      FieldTypes: new FormControl('', Validators.required),
    });
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateOrganizationCustomFieldCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .organizationCustomFieldsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateOrganizationCustomFieldCommand): void {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .organizationCustomFieldsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
    else this.baseCreateApi(this.model);
  }
}
